import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'message-circle-2', 'IconMessageCircle2', [["path",{"d":"M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1","key":"svg-0"}]]);